module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [(_vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "settings",
      "title": "Settings"
    }
  }, [_c('h2', [_vm._v("Finance Settings")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("Invoicing")])]), _vm._v(" "), _c('el-form', [_vm._v("\n                Select Sharer: "), _c('select-sharer', {
    model: {
      value: (_vm.telcoId),
      callback: function($$v) {
        _vm.telcoId = $$v
      },
      expression: "telcoId"
    }
  }), _vm._v(" "), _vm._l((_vm.settings.invoicing), function(inv, index) {
    return _c('el-row', {
      key: inv.id,
      attrs: {
        "gutter": 8
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [(_vm.telcoId) ? _c('check-box', {
      attrs: {
        "disabled": !_vm.canEdit
      },
      model: {
        value: (inv.send),
        callback: function($$v) {
          _vm.$set(inv, "send", $$v)
        },
        expression: "inv.send"
      }
    }, [_vm._v(_vm._s(inv.type))]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6,
        "align": "right"
      }
    }, [_c('el-form-item', [(inv.send) ? _c('el-button', {
      attrs: {
        "icon": "fa fa-clock",
        "type": inv.color,
        "disabled": !_vm.telcoId
      },
      on: {
        "click": inv.callback
      }
    }, [_vm._v("Run Now")]) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), _c('check-box', {
    attrs: {
      "label": "e-Mail",
      "label-width": "12rem",
      "disabled": true
    },
    model: {
      value: (_vm.settings.sendPDF),
      callback: function($$v) {
        _vm.$set(_vm.settings, "sendPDF", $$v)
      },
      expression: "settings.sendPDF"
    }
  }, [_vm._v("Send PDF to Recipient")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('br'), _vm._v(" "), _c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("Settings")])]), _vm._v(" "), _c('el-row', [_c('el-form', {
    attrs: {
      "props": _vm.settings,
      "label-width": "10rem"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tax Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.canEdit
    },
    model: {
      value: (_vm.settings.taxName),
      callback: function($$v) {
        _vm.$set(_vm.settings, "taxName", $$v)
      },
      expression: "settings.taxName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tax Rate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "disabled": !_vm.canEdit
    },
    model: {
      value: (_vm.settings.taxRate),
      callback: function($$v) {
        _vm.$set(_vm.settings, "taxRate", $$v)
      },
      expression: "settings.taxRate"
    }
  }, [_c('span', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v("%")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tax Number"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.canEdit
    },
    model: {
      value: (_vm.settings.taxNumber),
      callback: function($$v) {
        _vm.$set(_vm.settings, "taxNumber", $$v)
      },
      expression: "settings.taxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Standard Tems"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "disabled": !_vm.canEdit
    },
    model: {
      value: (_vm.settings.terms),
      callback: function($$v) {
        _vm.$set(_vm.settings, "terms", $$v)
      },
      expression: "settings.terms"
    }
  }, [_c('span', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v("days")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance|management')) ? _c('el-collapse-item', {
    attrs: {
      "name": "table",
      "title": "Agreements"
    }
  }, [_c('agreements-table')], 1) : _vm._e(), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "rates",
      "title": "Rate Tables"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Sharers",
      "lazy": ""
    }
  }, [_c('rates-table')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Tenancy",
      "lazy": ""
    }
  }, [_c('rates-table', {
    attrs: {
      "view": "tenancy"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Utility",
      "lazy": ""
    }
  }, [_c('rates-table', {
    attrs: {
      "view": "utility"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.canAccess('finance')) ? _c('el-collapse-item', {
    attrs: {
      "name": "builder",
      "title": "Agreements Builder"
    }
  }, [_c('agreements-builder')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7329bae6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/FinanceSettings.vue
// module id = 1551
// module chunks = 0